import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ContentTabs } from '@grandvisionhq/common';
import { Container } from '@grandvisionhq/elements';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '../../utils/http-client.js';
import { useBloomreachLinks } from '../../hooks/use-bloomreach-links.js';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';

const CmsLinkList = ({ content  })=>{
    const links = useBloomreachLinks(content.iconLinkCompoundList.map(({ link  })=>swcHelpers.objectSpread({}, link, {
            url: link.url || '#'
        })
    ));
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(ContentTabs, {
        links: links
    }));
};
var CmsLinkList$1 = compose(withBreakpointVisibility, withBloomreachData, withEditableContent, withAnchor)(CmsLinkList);

export { CmsLinkList, CmsLinkList$1 as default };
//# sourceMappingURL=LinkList.js.map
